import { saveConfig } from './config';
import { validators } from '../utils/validate';
import { logger } from '../utils/logger';

// HTML属性の更新
export const updateHtmlAttributes = (element, config) => {
  const attributes = {
    'data-bs-theme': config.theme,
    'data-menu-color': config.menu.color,
    'data-topbar-color': config.topbar.color,
    'data-layout-mode': config.layout.mode,
    'data-sidenav-size': config.sidenav.size
  };

  Object.entries(attributes).forEach(([attr, value]) => {
    if (value) element.setAttribute(attr, value);
  });
};

// テーマの変更
export const changeTheme = (config, theme) => {
  if (!validators.theme(theme)) {
    return logger.error(`Invalid theme: ${theme}`);
  }

  const newConfig = {
    ...config,
    theme
  };

  document.documentElement.setAttribute('data-bs-theme', theme);
  saveConfig(newConfig);
  logger.info(`Theme changed to: ${theme}`);
  
  // テーマ変更イベントを発行
  const themeChangedEvent = new CustomEvent('themeChanged', {
    detail: {
      theme: theme,
      previousTheme: config.theme,
      config: newConfig
    },
    bubbles: true
  });
  document.dispatchEvent(themeChangedEvent);
  
  return newConfig;
};

// テーマ切り替えの初期化
export const initThemeToggle = () => {
  const themeToggle = document.getElementById('light-dark-mode');
  if (!themeToggle) return;

  themeToggle.addEventListener('click', () => {
    const newTheme = window.config.theme === 'light' ? 'dark' : 'light';
    window.config = changeTheme(window.config, newTheme);
  });
}; 